import {
  subscriptionStatusEnum,
  paymentStatusEnum,
} from "@workspace/db/schema";

import type { EnumToConstant } from "@workspace/shared/types";

export const SubscriptionStatus = Object.fromEntries(
  Object.values(subscriptionStatusEnum.enumValues).map((status) => [
    status.toUpperCase(),
    status,
  ]),
) as EnumToConstant<typeof subscriptionStatusEnum.enumValues>;
export type SubscriptionStatus =
  (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export const PaymentStatus = Object.fromEntries(
  Object.values(paymentStatusEnum.enumValues).map((status) => [
    status.toUpperCase(),
    status,
  ]),
) as EnumToConstant<typeof paymentStatusEnum.enumValues>;
export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const BillingPlan = {
  FREE: "free",
  PREMIUM: "premium",
  ENTERPRISE: "enterprise",
} as const;
export type BillingPlan = (typeof BillingPlan)[keyof typeof BillingPlan];

export const OrganizationBillingPlan = {
  STARTER: "starter",
  PROFESSIONAL: "professional",
  PRACTICE: "practice",
  INTERNAL: "internal",
} as const;
export type OrganizationBillingPlan =
  (typeof OrganizationBillingPlan)[keyof typeof OrganizationBillingPlan];

export const OrganizationBillingInterval = {
  MONTHLY: "monthly",
  ANNUAL: "annual",
} as const;
export type OrganizationBillingInterval =
  (typeof OrganizationBillingInterval)[keyof typeof OrganizationBillingInterval];

export const OrganizationBillingVariant = {
  STARTER_MONTHLY: "starter_monthly",
  STARTER_ANNUAL: "starter_annual",
  PROFESSIONAL_MONTHLY: "professional_monthly",
  PROFESSIONAL_ANNUAL: "professional_annual",
  PRACTICE_MONTHLY: "practice_monthly",
  PRACTICE_ANNUAL: "practice_annual",
} as const;
export type OrganizationBillingVariant =
  (typeof OrganizationBillingVariant)[keyof typeof OrganizationBillingVariant];

export const BillingModel = {
  ONE_TIME: "one-time",
  RECURRING: "recurring",
} as const;

export const RecurringInterval = {
  DAY: "day",
  MONTH: "month",
  WEEK: "week",
  YEAR: "year",
} as const;

export const BillingType = {
  FLAT: "flat",
  PER_SEAT: "per-seat",
  METERED: "metered",
} as const;

export const BillingDiscountType = {
  PERCENT: "percent",
  AMOUNT: "amount",
} as const;

export const MobileStore = {
  APP_STORE: "app_store",
  PLAY_STORE: "play_store",
} as const;

export type MobileStore = (typeof MobileStore)[keyof typeof MobileStore];
export type BillingModel = (typeof BillingModel)[keyof typeof BillingModel];
export type RecurringInterval =
  (typeof RecurringInterval)[keyof typeof RecurringInterval];
export type BillingType = (typeof BillingType)[keyof typeof BillingType];
export type BillingDiscountType =
  (typeof BillingDiscountType)[keyof typeof BillingDiscountType];

export type {
  SelectCustomer as Customer,
  SelectSubscription as Subscription,
  SelectOrder as Order,
  SelectOrganizationSubscription as OrganizationSubscription,
} from "@workspace/db/schema";
